<template>
  <MakerCartGuideLayout
    pageTitle="Conducting a Maker Activity"
    heroImage="/images/maker-cart-guide/rectangle-4689.png"
    previousUrl="/makercart/guide/5"
    nextUrl="/makercart/guide/7"
  >
    <div class="x-guide6-content">
      <!-- Highlight Info Card -->
      <div class="x-highlight-card">
        <h2 class="x-highlight-title">Roles of a Facilitator</h2>
        <p class="x-highlight-text">
          The primary roles of the facilitator should include (i) designing
          suitable activities, (ii) posing questions, (iii) reacting to
          teachable moments using appropriate language, and (iv) conducting
          assessment.
        </p>
      </div>

      <!-- Role 1 -->
      <div class="x-role-section">
        <h3 class="x-role-title">Role 1: Designing Suitable Activities</h3>
        <p class="x-role-text">
          Designing engaging and effective maker activities is paramount to
          successful maker education. This section will explore key
          considerations for crafting activities that are both ambitious and
          attainable, while providing a framework for varying learner control
          and fostering deep thinking through the use of thinking routines.
        </p>
      </div>

      <!-- Role 2 -->
      <div class="x-role-section">
        <h3 class="x-role-title">Role 2: Posing Questions</h3>
        <p class="x-role-text">
          Effective questioning is the cornerstone of meaningful learning. This
          section explores how to craft powerful questions that spark curiosity,
          ignite imagination, and guide learners towards deeper understanding
          during maker activities. We will examine the power of open-ended
          questions, explore different question types, and discuss strategies
          for facilitating productive discussions and inquiry.
        </p>
      </div>

      <!-- Role 3 -->
      <div class="x-role-section">
        <h3 class="x-role-title">Role 3: Use appropriate language</h3>
        <div class="x-role-text">
          <p>
            The language we use can significantly impact learner engagement and
            understanding. This section delves into the importance of clear,
            concise, and accessible language for maker educators. This is
            especially important when the maker educator notices a teachable
            moment, and respond with questions or prompts that promote deeper
            thought as well as socio-emotional learning (SEL) competencies.
          </p>
          <p>
            To help illustrate how language use can invite rather than exclude,
            here are some language examples adapted from Youth Makerspace
            Playbook and other scenarios.
          </p>
        </div>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";
</script>

<style scoped>
.x-guide6-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.x-highlight-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: #e6f4ef;
  border: 1px solid #d8dae5;
  border-radius: 16px;
}

.x-highlight-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-xxl);
  line-height: 36px;
  color: var(--primary-blue);
  margin: 0;
}

.x-highlight-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.08px;
  color: var(--primary-blue);
  margin: 0;
}

.x-role-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
}

.x-role-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-xl);
  line-height: 32px;
  color: var(--primary-blue);
  margin: 0;
}

.x-role-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.08px;
  color: #3b4648;
  margin: 0;
}

.x-role-text p {
  margin: 0 0 16px 0;
}
.x-role-text p:last-child {
  margin: 0;
}
</style>
